/** @jsxImportSource @emotion/react */
import { FC, ReactNode, Ref } from 'react';
import { css, Grid, Paper, Typography } from '@mui/material';

type Props = {
  image: ReactNode;
  title: ReactNode;
  /** Bottom-left slot: price on the menu, quantity on the checkout. */
  left?: ReactNode;
  /** Bottom-right slot: add/remove controls on the menu, line total on the checkout. */
  right?: ReactNode;
  /** Ref on the right slot — the menu scrolls its controls into view after adding an item. */
  rightRef?: Ref<HTMLDivElement>;
  dimmed?: boolean;
};

/** Layout shared by the menu and checkout item cards: image, title, and a bottom row. */
const ItemCard: FC<Props> = ({
  image,
  title,
  left,
  right,
  rightRef,
  dimmed = false,
}) => (
  <Paper
    css={css`
      width: 100%;
      opacity: ${dimmed ? 0.4 : 1};
    `}
  >
    <Grid container spacing={1} wrap="nowrap">
      <Grid item>{image}</Grid>

      <Grid item xs>
        <Grid container direction="column" spacing={3}>
          <Grid item>
            <Typography
              css={css`
                word-break: break-word;
                overflow-wrap: anywhere;
                white-space: pre-line;
              `}
            >
              {title}
            </Typography>
          </Grid>

          <Grid item>
            <Grid
              container
              wrap="nowrap"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>{left}</Grid>

              {right ? (
                <Grid item ref={rightRef}>
                  {right}
                </Grid>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Paper>
);

export default ItemCard;
